<template>
    <div id="positionBanner">
       <!-- 左侧上方显示当前时间部分 -->
        <div class="position-time">
          <real-time></real-time>                                                                                                                                                                                                                                                           
        </div>
        <img src="../../../static/tg_images/dbbk.png" alt="pic" class="dbbk">
        <img src="../../../static/tg_images/icon.png" alt="" class="icon">
        <img  v-if="titleLogo.logo" :src="titleLogo.logo"  class="wz" >
        <div class="title-login" v-if="titleLogo.title">
            <div class="wz">{{titleLogo.title}}</div>
        </div>
        <div class="title-login" v-else>
            <img   alt="" class="icon">
            <div class="wz">
              <van-loading color="#98FDFF" size="24px" vertical>加载中...</van-loading>
            </div>
        </div>
        <!--预留logo以及title -->
        <!-- <p class="wz">{{titleLogo.title}}</p> -->
        <!-- <div class="quitBox" @click="quitLogin">
          <img src="../../../static/tg_images/tc.png" alt="pic" class="quit" width="32px" height="34px">
          <span class="quitLogin" >退出登录 </span>
        </div> -->
        <!-- 顶部左右各三个闪烁点 -->
        <div  v-for="(item,index) in leftShan.leftPath" :key="item" :class="[item,{'active':index==leftShan.leftCurrentIndex}]"  @click="changeIndex"></div>
        <div  v-for="(item,index) in rightShan.rightPath" :key="item" :class="[item,{'active':index==rightShan.rightCurrentIndex}]"  @click="changeIndex1"></div>
    </div>
</template>
<script>
  import realTime from '@/components/realTime/realTime'
  export default {
    data () {
      return {
        name:'positionBanner',
        leftShan:{//顶部左侧三个闪点
          leftTimer:null,
          leftCurrentIndex:0,
          leftPath:["leftShan","leftShan1","leftShan2"]
        },
        rightShan:{//顶部右侧三个闪点
          rightTimer:null,
          rightCurrentIndex:0,
          rightPath:["rightShan","rightShan1","rightShan2"]
        },
        titleLogo:{}
      }
    },
    components: {
      realTime,
    },
    mounted (){
      this.changeIndex(0);
      this.changeIndex1(2);
      this.getTitle()
    },
    methods: {
      // 顶部左侧三点闪烁
      changeIndex(index){
        clearInterval(this.leftShan.leftTimer)
        this.leftShan.leftTimer=setInterval(()=>{
          index++
          if(index>2){
            index=0
          }
          this.leftShan.leftCurrentIndex=index
        },600)
      },
      // 顶部右侧三点闪烁
      changeIndex1(index){
        clearInterval(this.rightShan.rightTimer)
        this.timer=setInterval(()=>{
          index--
          if(index<0){
            index=2
          }
          this.rightShan.rightCurrentIndex=index
        },600)
      },
      // 退出登录
      quitLogin(){
        this.$router.push('/login')
      },
      // 获取标题和logo
      getTitle(){
         $http.get('api/data_view/pole/info').then(res => {
            if(res.code == 1){
             this.titleLogo=res.data
             console.log(res);
            }else {
              Toast(res.msg)
            }
          });
      }
    },
  }
</script>

<style scoped>
  .positionBanner{
    position: relative;
  }
  .dbbk{
    width: 100%;
    position: absolute;
    top: 10px;
    left: 0px;
  }
  
  .position-time{
    position: absolute;
    z-index: 222;
    left: 46px;
    top: 22px;
    transition: transform 800ms ease 0s;
  }
  .icon{
    position: absolute;
    top: 18px;
    left: 654px;
  }
  .wz{
    position: absolute;
    left: 724px;
    top: 15px;
    width: 550px;
    height: 62px;
    margin: 0px;
    font-size: 56px;
    font-weight: bolder;
    font-family: AlibabaPuHuiTiH;
    text-shadow: 0px 0px 17px #efa100;
    color: #FFFFFF;
    line-height: 62px;
    letter-spacing: 12px;
  }
  .quitBox{
      cursor: pointer;
  }
  .quit{
    position: absolute;
    top: 20px;
    right: 108px;
  }
  .quitLogin{
    position: absolute;
    top: 26px;
    right: 32px;
    display: block;
    width: 64px;
    height: 22px;
    line-height: 22px;
    width: 64px;
    height: 22px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #E0F1FF;
    line-height: 22px;
  }

  .leftShan,.leftShan1,.leftShan2{
    position: absolute;
    top: 83px;
    left: 532px;
    width: 23px;
    height: 5px;
    background-color: #fff;
    opacity: .3;
    transform: skew(40deg);
  }
  
  .leftShan1{
    left: 562px;
  }
  .leftShan2{
    left: 593px;
  } 
  .rightShan,.rightShan1,.rightShan2{
    position: absolute;
    background-color: #fff;
    opacity: .3;
    top: 83px;
    left: 1305px;
    width: 23px;
    height: 5px;
    transform: skew(-40deg);
  }
 
 .rightShan1{
   left: 1336px;
  }
  .rightShan2{
    left: 1367px;
  } 
  /* 闪烁特效 */
 .active{
   background-color: #ffac20;
   opacity: 1;
 }
.active{
  transition: all .8s;
}

.title-login{
    display: flex;
    align-content: center;
    justify-content:center;
    width: 650px;
    position: relative;
    top: 10px;
    left:50%;
    transform: translateX(-50%);
     overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    /* border: 1px red solid; */
  }
</style>



// WEBPACK FOOTER //
// src/components/positionBanner/positionBanner.vue